import { render, staticRenderFns } from "./actions-column.vue?vue&type=template&id=1f596baa"
import script from "./actions-column.vue?vue&type=script&lang=js"
export * from "./actions-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f596baa')) {
      api.createRecord('1f596baa', component.options)
    } else {
      api.reload('1f596baa', component.options)
    }
    module.hot.accept("./actions-column.vue?vue&type=template&id=1f596baa", function () {
      api.rerender('1f596baa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/do-not-contact/actions-column.vue"
export default component.exports